import React from "react";
import LoadingSpin from "../../components/LoadingSpin";
import ErrorMessage from "../../components/ErrorMessage";
import {BrowserRouter as Router, Redirect} from "react-router-dom";
import {Form, FormCheck, Col, InputGroup, Button, ButtonGroup, Container, Row} from "react-bootstrap";
import {config} from "../../components/Constants";
import {Bar} from "react-chartjs-2";

class ClientsStats extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: true,
            isLoggedIn: false,
            redirect: null,
            allEvents: 0,
            finishedEvents: 0,
            canceledEvents: 0,
            calculations: 0,
            year: new Date().getFullYear(),
            chart: null,
            client: false
        };
        this.handleReturn = this.handleReturn.bind(this);
    }

    componentDidMount() {
        fetch(config.API_URL + '/api/clients/stats/' + this.props.match.params.id, {
            credentials: 'include'
        })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.error) {
                        this.setState({
                            client: null,
                            isLoaded: true,
                            year: new Date().getFullYear(),
                            allEvents: 0,
                            finishedEvents: 0,
                            canceledEvents: 0,
                            calculations: 0,
                            chart: null,
                            error: result.error
                        });
                    } else if (result) {
                        this.setState({
                            client: result.client,
                            allEvents: result.all,
                            year: result.year,
                            finishedEvents: result.finished,
                            canceledEvents: result.canceled,
                            calculations: result.calculations,
                            chart: result.chart,
                            isLoaded: true
                        });
                    }
                },
                (error) => {
                    this.setState({
                        client: null,
                        isLoaded: true,
                        year: new Date().getFullYear(),
                        allEvents: 0,
                        finishedEvents: 0,
                        canceledEvents: 0,
                        calculations: 0,
                        chart: null,
                        error: error
                    });
                }
            );
    }

    handleReturn(event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        this.setState({
            redirect: '/clients'
        });
        return false;
    }

    render() {
        const {error, isLoaded, isLoggedIn, redirect, client, allEvents, finishedEvents, canceledEvents, calculations, chart, year} = this.state;
        const data = {
            labels: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Październik', 'Listopad', 'Grudzień'],
            datasets: [
                {
                    label: 'Liczba przygotowywanych ofert na poszczególne miesiące w '+year,
                    backgroundColor: 'rgba(13,70,139,0.79)',
                    borderColor: 'rgba(13,70,139,1)',
                    borderWidth: 1,
                    hoverBackgroundColor: 'rgba(13,70,139,0.4)',
                    hoverBorderColor: 'rgba(13,70,139,1)',
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                }
            ]
        };
        if(chart){
            for(var x = 0; x < chart.length; x++){
                data.datasets[0].data[chart[x].miesiac - 1]=chart[x].ilosc;
            }
        }
        const that = this;
        if (!isLoaded || client === false) {
            return (
                <LoadingSpin/>
            );
        } else if (redirect !== null) {
            return <Redirect to={redirect}/>
        } else if (client === null) {
            return (
                <ErrorMessage title="Pojawiły się błędy" text={'Nie znaleziono klienta o ID: '+this.props.match.params.id} buttons={[
                    {'title': 'Powrót', 'callback': function() {that.setState({redirect: '/clients', client: {}});}}
                ]} handleClose={() => {that.setState({redirect: '/clients', client: {}});}}/>
            );
        } else if (error) {
            return (
                <ErrorMessage title="Pojawiły się błędy" text={error} buttons={[
                    {'title': 'Powrót', 'callback': function() {that.setState({redirect: '/clients', error: null});}}
                ]} handleClose={() => {that.setState({redirect: '/clients', error: null});}}/>
            );
        } else {
            return (
                <React.Fragment>
                    <header className="clients-header">
                        <h1>Statystyki obiektu: {client.nazwa}</h1>
                    </header>
                    <div className="section-div">
                        <Container fluid={true}>
                            <Row className="align-content-stretch MainPage-row">
                                <Col sm={12}>
                                    <h2>Wydarzenia {year}</h2>
                                </Col>
                            </Row>
                            <Row className="align-content-stretch MainPage-row">
                                <Col md={12} lg={6}>
                                    <ul>
                                        <li><strong>Wszystkie wydarzenia:</strong> {allEvents}</li>
                                        <li><strong>Wydarzenia zrealizowane:</strong> {finishedEvents}</li>
                                        <li><strong>Wydarzenia anulowane:</strong> {canceledEvents}</li>
                                        <li><strong>Kalkulacje:</strong> {calculations}</li>
                                    </ul>
                                </Col>
                                <Col md={12} lg={6}>
                                    <Bar
                                        data={data}
                                        width={100}
                                        height={40}
                                        options={{
                                            maintainAspectRatio: true,
                                            responsive: true
                                        }}
                                    />
                                    <div className="summary">
                                        <span>
                                            Imprez/Obiekty
                                        </span>
                                    </div>

                                </Col>
                            </Row>
                        </Container>
                    </div>
                </React.Fragment>
            );
        }
    }
}

export default ClientsStats;
